// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store.js'
import tunnels from './data/tunnels.js'
import services from './services/services.js'
import locationData from './data/location-data.json'
import redirects from './data/redirects.json'
import axios from 'axios'

Vue.config.productionTip = false
Vue.prototype.$http = axios

Vue.mixin({
  data () {
    return {
      ENV: process.env.CONFIG,
      locations: locationData,
      external: {
        twitterUrl: 'https://www.twitter.com/theTunnelBear',
        facebookUrl: 'https://www.facebook.com/TunnelBear',
        remembear: 'https://www.remembear.com',
        help: 'https://help.tunnelbear.com',
        audit: 'https://www.tunnelbear.com/blog/tunnelbear-completes-2nd-annual-independent-security-audit/',
        affiliate: 'https://signup.cj.com/member/signup/publisher/?cid=5172184',
        downloadLinks: {
          windows: 'https://tunnelbear.s3.amazonaws.com/downloads/pc/public/TunnelBear-Installer.exe',
          mac: 'https://s3.amazonaws.com/tunnelbear/downloads/mac/TunnelBear.zip',
          macV2: 'https://tunnelbear.s3.amazonaws.com/downloads/mac/TunnelBear-2.5.11.zip',
          ios: 'https://geo.itunes.apple.com/app/tunnelbear-vpn-unblock-websites/id564842283?mt=8&at=1010l9nk',
          android: 'https://play.google.com/store/apps/details?id=com.tunnelbear.android',
          chrome: 'https://chrome.google.com/webstore/detail/tunnelbear-vpn/omdakjcmkglenbhjadbccaookpfjihpa',
          opera: 'https://addons.opera.com/en/extensions/details/tunnelbear/',
          firefox: 'https://addons.mozilla.org/en-US/firefox/addon/tunnelbear-vpn-firefox/',
          blocker: 'https://chrome.google.com/webstore/detail/tunnelbear-blocker/bebdhgdigjiiamnkcenegafmfjoghafk'
        }
      },
      tunnels: tunnels
    }
  },
  methods: {
    urlEncodeData: function (data) {
      var buffer = []
      for (let key in data) {
        if (!data.hasOwnProperty(key)) continue
        let encodedKey = encodeURIComponent(key)
        let encodedValue = encodeURIComponent(data[key])
        buffer.push(encodedKey + '=' + encodedValue)
      }
      buffer = buffer.join('&')
      return buffer
    }
  }
})

/* eslint-disable no-constant-condition */
router.beforeEach((to, from, next) => {
  if (process.env.CONFIG.name !== 'development' && to.matched.some(record => record.meta.requiresAuth) && store.getters.isLoggedIn && !store.getters.tb4t) {
    window.location.href = '/account/overview'
    return
  }
  let urlParams = to.hash.split('?')
  let redirect = redirects[urlParams[0]]
  if (redirect) {
    let query = services.cleanQuery(urlParams[1])
    next({ path: redirect, query: query, meta: to.meta, params: to.params })
    return
  } else if (to.path.slice(-1) === '/' && to.path.length > 1) {
    let pathWithoutSlash = to.path.substring(0, to.path.length - 1)
    next({ path: pathWithoutSlash, query: to.query, hash: to.hash, meta: to.meta, params: to.params })
    return
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      store.commit('saveNextRoute', to)
      next({ replace: true, name: 'login' })
      return
    }
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js